// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1xz1M","colMin":"styles_colMin__I4-MB","colCheckbox":"styles_colCheckbox__3jND7"};